import AddAlt16 from '@carbon/icons-react/es/add--alt/16';
import Group16 from '@carbon/icons-react/es/group/16';
import ViewOff16 from '@carbon/icons-react/es/view--off/16';
import { Tooltip, Typography } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import {
  AddButton,
  StyledCollapseIcon,
  StyledExpandIcon,
} from 'components/organisms/projects/project-sidebar/spaces-menu/styles';
import { Caption01 } from 'components/styles';
import { useTranslation } from 'hooks/use-translation';

export const MenuTitleContainer = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const GroupTitle = styled(Typography.Text)`
  color: var(--gray-80);
  width: 150px;
  display: flex;
  gap: var(--spacing-05);

  svg {
    position: relative;
    top: 3px;
  }

  span {
    ${Caption01};
  }
`;

const IconShell = styled.span`
  position: relative;
  bottom: var(--spacing-01);
`;

interface MenuGroupTitlePropTypes {
  title: string;
  onSpaceAdd: (value: boolean) => void;
  collapseAll: () => void;
  collapse: boolean;
  isPrivate: boolean;
  isLoading?: boolean | undefined;
}

export const MenuGroupTitle: FC<MenuGroupTitlePropTypes> = ({
  title,
  onSpaceAdd,
  isLoading,
  collapseAll,
  collapse,
  isPrivate,
}) => {
  const handleAdd = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onSpaceAdd(isPrivate);
  };

  const handleCollapse = () => {
    (document.activeElement as HTMLElement).blur();
    if (collapseAll !== undefined) {
      collapseAll();
    }
  };
  const placeHolder = useTranslation(
    collapse === true ? 'collapse_all' : 'expand_all',
  );

  return (
    <MenuTitleContainer>
      <GroupTitle ellipsis={{ tooltip: true }}>
        <IconShell>{isPrivate ? <ViewOff16 /> : <Group16 />}</IconShell>
        <span>{title}</span>
      </GroupTitle>
      <div>
        {!isLoading && (
          <>
            <Tooltip title={placeHolder}>
              <AddButton
                onClick={handleCollapse}
                data-test-id="projects.spaces.collapse"
                disabled={isLoading}
                icon={
                  collapse === true ? (
                    <StyledCollapseIcon />
                  ) : (
                    <StyledExpandIcon />
                  )
                }
                className="add-button"
                size="small"
                type="text"
              />
            </Tooltip>

            <Tooltip title="Add new Space">
              <AddButton
                onClick={handleAdd}
                data-test-id="projects.spaces.new"
                disabled={isLoading}
                icon={<AddAlt16 />}
                className="add-button"
                size="small"
                type="text"
              />
            </Tooltip>
          </>
        )}
      </div>
    </MenuTitleContainer>
  );
};
